<template>
    <div
        v-if="instagram"
        class="l-grid"
    >
        <div class="c-gallery">
            <figure class="c-gallery__fig c-gallery__fig--1" v-parallax="-.2">
                <img
                    :src="recentPosts[0].thumbnail"
                    :data-src="recentPosts[0].standard"
                    loading="lazy"
                    alt=""
                    class="c-gallery__img | lazyload"
                >
            </figure>
            <figure class="c-gallery__fig c-gallery__fig--2" v-parallax=".4">
                <img
                    :src="recentPosts[1].thumbnail"
                    :data-src="recentPosts[1].standard"
                    loading="lazy"
                    alt=""
                    class="c-gallery__img | lazyload"
                >
            </figure>
            <div class="c-gallery__inner">
                <div class="c-gallery__content">
                    <h2 class="c-gallery__title | t-t1-serif">
                        {{ title }}&nbsp;
                        <Icon icon="logo-icon" />
                    </h2>
                    <a
                        :href="instagramProfile"
                        :title="`${siteName} sur Instagram`"
                        class="c-gallery__instagram"
                    >
                        <Icon icon="instagram" />
                    </a>
                </div>
            </div>
            <figure class="c-gallery__fig c-gallery__fig--3" v-parallax="-.1">
                <img
                    :src="recentPosts[2].thumbnail"
                    :data-src="recentPosts[2].standard"
                    loading="lazy"
                    alt=""
                    class="c-gallery__img | lazyload"
                >
            </figure>
        </div>
    </div>
</template>

<script>/* eslint-disable */

    import Icon from 'components/Icon'
    import 'lazysizes'

    export default {
        name: 'Instagram',
        components: {
            Icon
        },
        props: {
            title: {
                type: String,
                default: 'La relation la plus saine que vous aurez eu jusqu’à maintenant'
            },
        },
        computed: {

            site()  {

                if ( !this.$store.state.site.site )
                    return

                return this.$store.state.site.site

            },
            siteName() {

                if ( !this.site )
                    return

                return this.site.settings.site_name

            },
            instagramProfile() {

                if ( !this.site )
                    return

                const instagram = this.site.restaurant.accounts.find(account => account.name === 'instagram')

                return instagram.url

            },
            instagram() {

                if ( !this.site )
                    return

                return this.site.instagram

            },
            recentPosts() {

                if ( !this.site )
                    return

                if ( !this.instagram )
                    return

                return this.instagram.recentPosts

            }
        }
    }
</script>

<style scoped>
</style>
